<template lang="pug">
  .rhpa.force-mobile(v-if="buyRequest" @mousedown.stop="")
    rhpa-programming(v-if="isProgram" :product="product" ref="programming")
    rhpa-body(:buy-request="buyRequest" )
    rhpa-footer(
      :buy-request="buyRequest"
      :hide-qty="true"
      :hide-wishlist="true"
      :force-show-price="true"
      :disabled="false"
      :validate="validate"
      :disableDigitalWallets="true"
      :compact="true"
    )
</template>
<script>
import { defineAsyncComponent } from 'vue'
import { useProductStore } from '@/js/stores/productStore'
import RhpaBody from '@/js/components/rhpa/rhpa-body.vue'
import RhpaFooter from '@/js/components/rhpa/rhpa-footer.vue'
import { createBuyRequest } from '@/js/helpers/buy-request'

export default {
  components: {
    RhpaFooter,
    RhpaBody,
    RhpaProgramming: defineAsyncComponent(() => import(/* webpackChunkName: "a2c-rhpa-programming" */ '@/js/components/rhpa/programs/rhpa-programming.vue')),
  },
  props: {
    productId: {
      type     : Number,
      required : true,
    },
  },

  setup() {
    const productStore = useProductStore()

    return { productStore }
  },

  data: () => ({
    buyRequest: null,
  }),

  computed: {
    products() {
      return this.productStore.products
    },

    product() {
      return this.products[this.productId]
    },

    isProgram() {
      return this.product?.isProgram
    },
  },

  async serverPrefetch() {
    await this.load()
  },

  watch: {
    productId() {
      this.load()
    },
  },

  created() {
    if (!this.$rogue.ssr) {
      this.load()
    }
  },

  methods: {
    async load() {
      try {
        if (!this.productStore.allChildrenLoaded(this.productId)) {
          await this.productStore.loadAllChildren(this.productId, this.$rogue)
        }
        this.buyRequest = createBuyRequest(this.products[this.productId], this.$rogue)
      } catch (e) {
        this.$rogue.log.info('Unable to create buy request for advanced product list', e)
      }
    },
    async validate() {
      if (this.product?.isProgram) {
        const valid = await this.$refs.programming?.validate()

        return valid
      }

      return true
    },
  },
}
</script>
<style lang="scss" scoped>

</style>
